"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERIFY_FAIL_LOCK_MS = exports.VERIFY_FAIL_LIMIT = exports.STORAGE_KEY = exports.REFRESH_WINDOW_MS = exports.REFRESH_LOCK_MS = exports.REFRESH_LIMIT = exports.LOCK_TITLES = void 0;
exports.clearSliderRequired = clearSliderRequired;
exports.clearSliderVerifyFailures = clearSliderVerifyFailures;
exports.getActiveLock = getActiveLock;
exports.getDefaultSliderSecurityState = getDefaultSliderSecurityState;
exports.isSliderInteractionLocked = isSliderInteractionLocked;
exports.isSliderRequired = isSliderRequired;
exports.markSliderRequired = markSliderRequired;
exports.normalizeSliderSecurityState = normalizeSliderSecurityState;
exports.readSliderSecurityState = readSliderSecurityState;
exports.recordSliderGateOpen = recordSliderGateOpen;
exports.recordSliderRefreshClick = recordSliderRefreshClick;
exports.recordSliderVerifyFailure = recordSliderVerifyFailure;
exports.resetSliderSecurityState = resetSliderSecurityState;
exports.syncSliderSecurityStateOnPageLoad = syncSliderSecurityStateOnPageLoad;
exports.unlockSliderInteraction = unlockSliderInteraction;
exports.writeSliderSecurityState = writeSliderSecurityState;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var STORAGE_KEY = exports.STORAGE_KEY = 'login_slider_state';
var REFRESH_LIMIT = exports.REFRESH_LIMIT = 5;
var REFRESH_WINDOW_MS = exports.REFRESH_WINDOW_MS = 60 * 1000;
var REFRESH_LOCK_MS = exports.REFRESH_LOCK_MS = 60 * 1000;
var VERIFY_FAIL_LIMIT = exports.VERIFY_FAIL_LIMIT = 5;
var VERIFY_FAIL_LOCK_MS = exports.VERIFY_FAIL_LOCK_MS = 60 * 1000;
var LOCK_TITLES = exports.LOCK_TITLES = {
  refresh: '操作过于频繁，请1分钟后再试',
  verify: '验证失败次数过多，请1分钟后再试'
};
function getDefaultSliderSecurityState() {
  return {
    refreshTimestamps: [],
    verifyFailCount: 0,
    refreshLockUntil: null,
    verifyLockUntil: null,
    sliderRequired: false
  };
}
function normalizeSliderSecurityState(raw) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  var state = _objectSpread(_objectSpread({}, getDefaultSliderSecurityState()), raw || {});

  // 60 秒窗口外的操作记录过期
  state.refreshTimestamps = (state.refreshTimestamps || []).filter(function (ts) {
    return now - ts < REFRESH_WINDOW_MS;
  });

  // 1 分钟锁定到期自动解除
  if (state.refreshLockUntil && state.refreshLockUntil <= now) {
    state.refreshLockUntil = null;
    state.refreshTimestamps = [];
  }
  if (state.verifyLockUntil && state.verifyLockUntil <= now) {
    state.verifyLockUntil = null;
    state.verifyFailCount = 0;
  }

  // 无有效锁定、无窗口内操作、无失败计数 → 不再需要滑块标记
  if (!getActiveLock(state, now) && state.refreshTimestamps.length === 0 && state.verifyFailCount === 0) {
    state.sliderRequired = false;
  }
  return state;
}
function getActiveLock(state) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  if (state.verifyLockUntil && state.verifyLockUntil > now) {
    return {
      type: 'verify',
      lockUntil: state.verifyLockUntil
    };
  }
  if (state.refreshLockUntil && state.refreshLockUntil > now) {
    return {
      type: 'refresh',
      lockUntil: state.refreshLockUntil
    };
  }
  return null;
}

/**
 * 页面刷新/进入登录页时主动比对 storage 中的时间戳，过期则自动清理。
 */
function syncSliderSecurityStateOnPageLoad() {
  var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
  var raw = null;
  try {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      return {
        locked: false,
        sliderRequired: false,
        cleared: false,
        state: null
      };
    }
    raw = JSON.parse(stored);
  } catch (e) {
    resetSliderSecurityState();
    return {
      locked: false,
      sliderRequired: false,
      cleared: true,
      state: null
    };
  }
  var state = normalizeSliderSecurityState(raw, now);
  var activeLock = getActiveLock(state, now);
  var shouldRemove = !activeLock && !state.sliderRequired && state.refreshTimestamps.length === 0 && state.verifyFailCount === 0;
  if (shouldRemove) {
    resetSliderSecurityState();
    return {
      locked: false,
      sliderRequired: false,
      cleared: true,
      state: null
    };
  }
  writeSliderSecurityState(state);
  return {
    locked: !!activeLock,
    lockType: activeLock ? activeLock.type : null,
    lockUntil: activeLock ? activeLock.lockUntil : null,
    sliderRequired: !!state.sliderRequired,
    cleared: false,
    state: state
  };
}
function readSliderSecurityState() {
  return syncSliderSecurityStateOnPageLoad().state;
}
function writeSliderSecurityState(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // ignore quota / privacy mode errors
  }
}
function isSliderInteractionLocked() {
  return syncSliderSecurityStateOnPageLoad().locked;
}
function isSliderRequired() {
  return syncSliderSecurityStateOnPageLoad().sliderRequired;
}
function markSliderRequired() {
  var state = normalizeSliderSecurityState(readSliderSecurityState());
  state.sliderRequired = true;
  writeSliderSecurityState(state);
}
function clearSliderRequired() {
  var state = normalizeSliderSecurityState(readSliderSecurityState());
  state.sliderRequired = false;
  writeSliderSecurityState(state);
}
function recordSliderGateOpen() {
  var state = normalizeSliderSecurityState(readSliderSecurityState());
  state.sliderRequired = true;
  var activeLock = getActiveLock(state);
  if (activeLock) {
    writeSliderSecurityState(state);
    return {
      locked: true,
      lockType: activeLock.type,
      lockUntil: activeLock.lockUntil
    };
  }
  var now = Date.now();
  state.refreshTimestamps.push(now);
  if (state.refreshTimestamps.length >= REFRESH_LIMIT) {
    state.refreshLockUntil = now + REFRESH_LOCK_MS;
    writeSliderSecurityState(state);
    return {
      locked: true,
      lockType: 'refresh',
      lockUntil: state.refreshLockUntil,
      justLocked: true
    };
  }
  writeSliderSecurityState(state);
  return {
    locked: false
  };
}
function recordSliderRefreshClick() {
  return recordSliderGateOpen();
}
function recordSliderVerifyFailure() {
  var state = normalizeSliderSecurityState(readSliderSecurityState());
  var activeLock = getActiveLock(state);
  if (activeLock) {
    return {
      locked: true,
      lockType: activeLock.type,
      lockUntil: activeLock.lockUntil
    };
  }
  state.verifyFailCount += 1;
  if (state.verifyFailCount >= VERIFY_FAIL_LIMIT) {
    state.verifyLockUntil = Date.now() + VERIFY_FAIL_LOCK_MS;
    writeSliderSecurityState(state);
    return {
      locked: true,
      lockType: 'verify',
      lockUntil: state.verifyLockUntil,
      justLocked: true
    };
  }
  writeSliderSecurityState(state);
  return {
    locked: false
  };
}
function clearSliderVerifyFailures() {
  var state = normalizeSliderSecurityState(readSliderSecurityState());
  state.verifyFailCount = 0;
  writeSliderSecurityState(state);
}
function unlockSliderInteraction(type) {
  var state = normalizeSliderSecurityState(readSliderSecurityState());
  if (type === 'refresh') {
    state.refreshLockUntil = null;
    state.refreshTimestamps = [];
  } else {
    state.verifyLockUntil = null;
    state.verifyFailCount = 0;
  }
  writeSliderSecurityState(state);
}
function resetSliderSecurityState() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(LEGACY_STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch (e) {
    // ignore
  }
}